import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { servicePackages } from '../../data/services';

const ServicePackages = () => {
  return (
    <section className="section section-cream">
      <div className="container">
        <div className="section-header">
          <div className="badge">Our Services</div>
          <h2>Choose Your Perfect Package</h2>
          <p>From essential cleaning to complete detailing, we have a package to suit every need and budget</p>
        </div>

        <div className="grid grid-4" style={{marginBottom: '3rem', marginTop:'3rem'}}>
          {servicePackages.map((pkg) => (
            <Card key={pkg.id} hover className={`service-card ${pkg.popular ? 'popular' : ''}`}>
              {pkg.popular && (
                <div className="service-card-badge">MOST POPULAR</div>
              )}
              
              <div className="service-card-header">
                <h3 className="service-card-name">{pkg.name}</h3>
                <div className="service-card-tagline">{pkg.tagline}</div>
                <div className="service-card-price">{pkg.price}</div>
                <div className="service-card-duration">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  {pkg.duration}
                </div>
              </div>

              <ul className="service-card-features">
                {pkg.features.slice(0, 5).map((feature, idx) => (
                  <li key={idx}>
                    <Check size={16} color="var(--green-500)" />
                    <span>{feature}</span>
                  </li>
                ))}
                {pkg.features.length > 5 && (
                  <li style={{color: 'var(--main-blue)', fontWeight: 600}}>
                    +{pkg.features.length - 5} more features
                  </li>
                )}
              </ul>

              <Link to="/services" state={{ selectedPackage: pkg.id }}>
                <Button 
                  variant={pkg.popular ? 'primary' : 'outline'} 
                  size="sm"
                  className="w-full"
                  icon={ArrowRight}
                >
                  View Details
                </Button>
              </Link>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/services">
            <Button variant="primary" size="lg">
              View All Services & Pricing
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicePackages;